// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"366":"01f8b7855f634e62","539":"adaf8687b9dca038"}[chunkId] + ".js";
};